import { api } from 'shared/api/common'

const baseUrl = '/api/v3/supplier/payments'

export function getStripeOnboardingStatus () {
  return api.get(`${baseUrl}/payout-account/stripe/`)
}

export function getStripeOnboardingUrl () {
  return api.get(`${baseUrl}/payout-account/stripe/onboarding-url/`)
}

export function getStripeDashboardUrl () {
  return api.get(`${baseUrl}/payout-account/stripe/dashboard-url/`)
}
